import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// PARTIAL FD / CLOSE FD VERIFICATION
// Legacy: /AccountsApproval/VerifyPartialFD and /AccountsApproval/VerifyCloseFD — legacy renders both
// through VerifyPartialFDView and approves both with ApprovePartialFD; only queue/detail routes differ.
const ROUTES = {
    Partial: { queue: 'GetVerificationPartialFD', detail: 'GetPartialFDbyTransno' },
    Close: { queue: 'GetVerificationCloseFD', detail: 'GetCloseFDbyTransno' },
};
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — partial / full FD closures pending at this role's level.
export const getVerificationPartialFDs = async (roleId, mode = 'Partial') => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/${ROUTES[mode].queue}`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail: maturity / interest split, new FD after the partial closure, deductions, payment and MOID.
export const getPartialFDByTransNo = async (transactionNo, mode = 'Partial') => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/${ROUTES[mode].detail}`, { params: { Transactionno: transactionNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApprovePartialFD — success literal "Submitted").
export const approvePartialFD = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApprovePartialFD`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
